import { Button } from "../../../../lib/components";
import PropTypes from "prop-types";
import React from "react";
import moment from "moment";
import styles from "../../../../assets/scss/pages/news.module.scss";
import { useHistory } from "react-router-dom";
import { InfoCard, InfoCardHeader, InfoCardBody } from "../../../../lib/components/InfoCard";

const NewsCard = (props) => {
  const { item, onClick } = props;
  const history = useHistory();

  return (
    <InfoCard height={"large"}>
      <InfoCardHeader
        className={styles.cardHeaderColor}
        title={item.title}
        tag={item.type ?? "local"}
      ></InfoCardHeader>
      <InfoCardBody image={item.images[0]}>
        <div className={styles.content}>
          <div className={`${styles.quillContainer} ql-container ql-snow`}>
            <div className={`${styles.quillEditor} ql-editor`} dangerouslySetInnerHTML={{ __html: item.content }}></div>
          </div>
          <div className={styles.actuActions}>
            <span className={styles.actuDate}>Publié le {moment(item.date.toDate()).format("DD/MM/YYYY")}</span>
            <Button color="primary" onClick={onClick} className={styles.button}>Consulter</Button>
          </div>
        </div>
      </InfoCardBody>
    </InfoCard>            
  );
};

NewsCard.propTypes = {
  onClick: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
};

export default NewsCard;
